module.exports = __webpack_public_path__ + "resources/sass/fn/fonts/OpenSans-Regular-webfont.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/resources/sass/fn/fonts/OpenSans-Regular-webfont.ttf
// module id = 355
// module chunks = 0